const React = require( 'react' );

const loadable = require( '@ulta/core/components/Loadable' ).default;
const { LayerHost } = require( '@ulta/core/components/LayerHost/LayerHost' );


// DSOTF2-114516 - Subset of Components shared between HOME, PLP, PDP
const { AppDetails } = require( '@ulta/modules/AppDetails/AppDetails' );
const { BagIcon } = require( '@ulta/modules/BagIcon/BagIcon' );
const { ColumnContainer } = require( '@ulta/modules/ColumnContainer/ColumnContainer' );
const { DataCaptureEvent } = require( '@ulta/modules/DataCaptureEvent/DataCaptureEvent' );
const { FavoritesUtilityLink } = require( '@ulta/modules/FavoritesUtilityLink/FavoritesUtilityLink' );
const { GridContainer } = require( '@ulta/modules/GridContainer/GridContainer' );
const { IncrementalModule } = require( '@ulta/modules/IncrementalModule/IncrementalModule' );
const { Image } = require( '@ulta/modules/Image/Image' );
const { ImageNavigation } = require( '@ulta/modules/ImageNavigation/ImageNavigation' );
const { JSscriptTag } = require( '@ulta/modules/JSscriptTag/JSscriptTag' );
const { MainWrapper } = require( '@ulta/modules/MainWrapper/MainWrapper' );
const { NavigationLinksGroup } = require( '@ulta/modules/NavigationLinksGroup/NavigationLinksGroup' );
const { NavigationLinksSubGroup } = require( '@ulta/modules/NavigationLinksSubGroup/NavigationLinksSubGroup' );
const { NavigationOverlay } = require( '@ulta/modules/NavigationOverlay/NavigationOverlay' );
const { NavigationOverlayFeaturedContent } = require( '@ulta/modules/NavigationOverlayFeaturedContent/NavigationOverlayFeaturedContent' );
const { Page } = require( '@ulta/modules/Page/Page' );
const { PrimaryBar } = require( '@ulta/modules/PrimaryBar/PrimaryBar' );
const { PrimaryLinks } = require( '@ulta/modules/PrimaryLinks/PrimaryLinks' );
const { Sdk } = require( '@ulta/modules/Sdk/Sdk' );
const { SearchHeader } = require( '@ulta/modules/SearchHeader/SearchHeader' );
const { Spacer } = require( '@ulta/modules/Spacer/Spacer' );
const { StateWrapper } = require( '@ulta/modules/StateWrapper/StateWrapper' );
const { VerticalSlot } = require( '@ulta/modules/VerticalSlot/VerticalSlot' );
const { WebPageMetaData } = require( '@ulta/modules/WebpageMetaData/WebpageMetaData' );

const LoadableComponent = props => {

  /*
   * do not remove thee useMemo here without a long drawn out conversation with the
   * UI Architecture team por Fávor
   */
  const Component = React.useMemo( () => loadable( () => import(
    /* webpackChunkName: "[request]" */
    /* webpackInclude: /\.js$/ */
    /* webpackExclude: /.*(test|stories)\.js$/ */
    `@ulta/modules/${props.moduleName}/${props.moduleName}.js`
  ) ), [props.moduleName] );

  Component.preload();

  return (
    <LayerHost
      Content={ Component }
      displayName={ props.moduleName }// testing for new loadable implm
      { ...props }
    />
  );
};


module.exports = LoadableComponent;
